module.exports = __webpack_public_path__ + "images/people/people-with-tablet@2x-940fdcf11863e7d4efe964815e6d2fc6.webp";